import globalTheme from '../global'

const Dialog = {
	MuiDialog: {
		styleOverrides: {
			paper: {
				...globalTheme.scrollbarJsx,
				display: 'block',
				width: '100%',
				margin: globalTheme.spacing(3),
				minHeight: 'auto',
				[globalTheme.breakpoints.up('md')]: {
					margin: globalTheme.spacing(4),
				},
			},
			paperWidthSm: {
				padding: '56px 25px 32px',
				'& .iconClose': {
					right: '10px',
					top: '10px',
				},
				[globalTheme.breakpoints.up('md')]: {
					minHeight: 'max-content',
				},
			},
			paperWidthMd: {
				maxWidth: '720px',
				padding: '85px 120px',
				'& .iconClose': {
					right: '14px',
					top: '14px',
				},
				[globalTheme.breakpoints.up('md')]: {
					minHeight: '405px',
				},
			},
			paperWidthLg: {
				maxWidth: '880px',
				padding: '118px 140px',
				'& .iconClose': {
					right: '22px',
					top: '22px',
				},
				[globalTheme.breakpoints.up('md')]: {
					minHeight: '495px',
				},
			},
			paperWidthXl: {
				'& .iconClose': {
					right: '22px',
					top: '22px',
				},
			},
			paperWidthFalse: {
				'& .iconClose': {
					right: '10px',
					top: '10px',
					[globalTheme.breakpoints.up('md')]: {
						right: '14px',
						top: '14px',
					},
					[globalTheme.breakpoints.up('lg')]: {
						right: '22px',
						top: '22px',
					},
				},
			},
			paperFullScreen: {
				margin: 0,
				minHeight: 'calc(var(--vh, 1vh) * 100)',
			},
		},
		defaultProps: {
			variant: 'lg',
		},
	},
	MuiDialogActions: {
		styleOverrides: {
			root: {
				display: 'flex',
				justifyContent: 'center',
				flexWrap: 'wrap',
				width: '100%',
				padding: 0,
				'> .MuiButton-root': {
					marginLeft: '24px',
					width: '100%',
					maxWidth: '100%',
					[globalTheme.breakpoints.up('md')]: {
						maxWidth: '186px',
					},
				},
			},
		},
	},
}

export default Dialog
